import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { HelmetProvider } from 'react-helmet-async';

import Home from './pages/Home';
import AboutPage from './pages/AboutPage';
import CreatorProfile from './components/CreatorProfile/CreatorProfile';
import CreatorDashboard from './pages/CreatorDashboard';
import CreatorProjects from './pages/CreatorProjects';
import CreatorBids from './pages/CreatorBids';
import LiveCampaignsPage from './pages/LiveCampaignsPage';
import LiveBidsPage from './pages/LiveBidsPage';
import BrandDashboard from './pages/BrandDashboard';
import BrandCampaignsPage from './pages/BrandCampaignsPage';
import BrandCreatorsPage from './pages/BrandCreatorsPage';
import BrandMyAccount from './pages/BrandMyAccount';
import ProtectedRoute from './components/ProtectedRoute';
import AdminProtectedRoute from './components/AdminProtectedRoute';
import SignUpPage from './pages/SignUpPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import CampaignDetailsPage from './components/brand/CampaignDetailsPage';
import CreatorProfilePage from './components/CreatorProfile/CreatorProfilePage';
import ProfileLayout from './components/profile/ProfileLayout';
import ContactPage from './pages/ContactPage';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import SponsorshipListPage from './pages/SponsorshipListPage';
import SponsorshipCreatePage from './pages/SponsorshipCreatePage';
import SponsorshipDetailsPage from './pages/SponsorshipDetailsPage';
import SponsorshipEditPage from './pages/SponsorshipEditPage';
import CreatorSponsorshipsPage from './pages/CreatorSponsorshipsPage';
import CollaboratorClubPage from './pages/CollaboratorClubPage';

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/creator/:id" element={<CreatorProfile />} />
            <Route path="/signup" element={<SignUpPage/>}/>
            <Route path="/forgot-password" element={<ForgotPasswordPage/>}/>

            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin/dashboard"
              element={
                <AdminProtectedRoute>
                  <AdminDashboard />
                </AdminProtectedRoute>
              }
            />

            {/* Sponsorship Routes - List/Details only for Brands */}
            <Route
              path="/sponsorships"
              element={
                <ProtectedRoute allowedRoles={['brand']}>
                  <SponsorshipListPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/sponsorships/:id"
              element={
                <ProtectedRoute allowedRoles={['brand']}>
                  <SponsorshipDetailsPage />
                </ProtectedRoute>
              }
            />
            {/* Creator-only: create and manage their own sponsorships */}
            <Route
              path="/sponsorships/new"
              element={
                <ProtectedRoute allowedRoles={['creator']}>
                  <SponsorshipCreatePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/creator/sponsorships"
              element={
                <ProtectedRoute allowedRoles={['creator']}>
                  <CreatorSponsorshipsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/creator/sponsorships/:id"
              element={
                <ProtectedRoute allowedRoles={['creator']}>
                  <SponsorshipDetailsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/creator/sponsorships/:id/edit"
              element={
                <ProtectedRoute allowedRoles={['creator']}>
                  <SponsorshipEditPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/dashboard/creator"
              element={
                <ProtectedRoute allowedRoles={['creator']}>
                  <CreatorDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/creator/projects"
              element={
                <ProtectedRoute allowedRoles={['creator']}>
                  <CreatorProjects />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/creator/live-campaigns"
              element={
                <ProtectedRoute allowedRoles={['creator']}>
                  <LiveCampaignsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/creator/bids"
              element={
                <ProtectedRoute allowedRoles={['creator']}>
                  <CreatorBids />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/creator/collaborator-club"
              element={
                <ProtectedRoute allowedRoles={['creator']}>
                  <CollaboratorClubPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/brand"
              element={
                <ProtectedRoute allowedRoles={['brand']}>
                  <BrandDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/brand/campaigns"
              element={
                <ProtectedRoute allowedRoles={['brand']}>
                  <BrandCampaignsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/brand/live-bids"
              element={
                <ProtectedRoute allowedRoles={['brand']}>
                  <LiveBidsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/brand/creators"
              element={
                <ProtectedRoute allowedRoles={['brand']}>
                  <BrandCreatorsPage />
                </ProtectedRoute>
              }
            />
            <Route path="/dashboard/brand/campaigns/:id" element={<CampaignDetailsPage />} />
            <Route
              path="/dashboard/brand/my-account/:userId"
              element={
                <ProtectedRoute allowedRoles={['brand']}>
                  <BrandMyAccount />
                </ProtectedRoute>
              }
            />
            <Route path="/dashboard/creator/profile" element={<CreatorProfilePage />} />
            <Route
              path="/dashboard/creator/profile-manage/:userId"
              element={
                <ProtectedRoute allowedRoles={['creator']}>
                  <ProfileLayout />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Router>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
